import { programEnums } from '../../enums'
import { programTypes } from '../../types'

class Program {
  CODE: programEnums.codes

  core?: programTypes.Core

  markdown?: programTypes.Markdown

  constructor(
    config:
      { code: programEnums.codes, core?: programTypes.Core, markdown?: programTypes.Markdown },
  ) {
    this.CODE = config.code
    this.core = config.core
    this.markdown = config.markdown
  }
}

export default Program
